export const PATIENT_DETAIL_TABS = ['dashboard', 'patientData', 'applications', 'financial'];

export const isValidPatientDetailTab = (tab) => PATIENT_DETAIL_TABS.includes(tab);

export const getPatientDetailsPath = (patientId, tab = 'dashboard') => {
  const params = new URLSearchParams();

  if (patientId) {
    params.set('id', String(patientId));
  }

  if (tab && tab !== 'dashboard' && isValidPatientDetailTab(tab)) {
    params.set('tab', tab);
  }

  const query = params.toString();
  return query ? `/pacientes/detalhes?${query}` : '/pacientes/detalhes';
};
